module.exports = __webpack_public_path__ + "img/Imagen 1.7046014c.jpg";